<template>
  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    :return-value.sync="date"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="textDate"
        label="Pick Date"
        prepend-icon="mdi-calendar"
        readonly
        :value="dateFormatted"
        v-bind="attrs"
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker v-model="date" no-title scrollable @change="pickedDate()">
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
      <v-btn text color="primary" @click="$refs.menu.save(date)"> OK </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from "moment";
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
export default {
  computed: {
    dateFormatted() {
      var iso = moment.utc(this.date).format();
      this.selectedDate = moment(this.date).format("YYYY/MM/DD");
      var utc = moment(iso).format("dddd, MMMM Do YYYY, h:mm:ss a").split(",");
      var date = utc[0] + utc[1].toString();

      this.textDate = moment(this.date).format("L");
      this.dateSelected({
        payload: {
          date: this.selectedDate,
        },
      });
    },
  },
  data: () => ({
    menu: false,
    editDate: "",
    showEdit: false,
    showPicker: false,
    textDate: null,
    selectedDate: "",
    date: new Date().toISOString().substr(0, 10),
  }),
  methods: {
    ...mapActions("shared", ["dateSelected"]),
    pickedDate() {
      this.showEdit = false;
      this.showPicker = true;
    },
  },
  props: {
    dateTimeStamp: {
      type: Number,
      required: false,
    },
  },
  watch: {
    dateTimeStamp: {
      immidate: true,
      handler(value) {
        this.textDate = value;
        var iso, utc, date;
        iso = moment.utc(value * 1000).format();
        utc = moment(iso).format("YYYY-MM-DD");
        this.date = utc;
      },
    },
  },
};
</script>